/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommitImageRequest
 */
export interface CommitImageRequest {
    /**
     * 
     */
    objectKey?: string;
    /**
     * 
     */
    purpose?: string;
}

/**
 * Check if a given object implements the CommitImageRequest interface.
 */
export function instanceOfCommitImageRequest(value: object): value is CommitImageRequest {
    return true;
}

export function CommitImageRequestFromJSON(json: any): CommitImageRequest {
    return CommitImageRequestFromJSONTyped(json, false);
}

export function CommitImageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommitImageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'objectKey': json['objectKey'] == null ? undefined : json['objectKey'],
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
    };
}

export function CommitImageRequestToJSON(json: any): CommitImageRequest {
    return CommitImageRequestToJSONTyped(json, false);
}

export function CommitImageRequestToJSONTyped(value?: CommitImageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectKey': value['objectKey'],
        'purpose': value['purpose'],
    };
}

